import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery } from '@tanstack/react-query';
import { MessageHistoryApi } from 'api';

/**
 * [MessageHistory] Query key 생성
 * --
 */
export const messageHistoryQueryKeys = createQueryKeys('message_history', {
  getMessageHistory: (idx, params) => [idx, params],
  getMessageHistories: (params) => [params],
});

/**
 * [MessageHistory] 메시지 전송내역 전체 조회
 * --
 */
export const useGetMessageHistories = (params, options) => {
  const data = useQuery({
    queryKey: messageHistoryQueryKeys.getMessageHistories(params).queryKey,
    queryFn: () => MessageHistoryApi.getMessageHistories(params),
    ...options,
  });
  return data;
};

/**
 * [MessageHistory] 메시지 전송내역 상세 조회
 * --
 */
export const useGetMessageHistory = (idx, params, options) => {
  const data = useQuery({
    queryKey: messageHistoryQueryKeys.getMessageHistory(idx, params).queryKey,
    queryFn: () => MessageHistoryApi.getMessageHistory(idx, params),
    ...options,
  });

  return data;
};

/**
 * [MessageHistory] 메시지 전송내역 생성
 * --
 */
export const useCreateMessageHistory = () => {
  const { mutateAsync: createMessageHistory, ...result } = useMutation({
    mutationFn: (variables) =>
      MessageHistoryApi.createMessageHistory(variables),
  });

  return { createMessageHistory, ...result };
};

/**
 * [MessageHistory] 메시지 전송내역 수정
 * --
 */
export const useUpdateMessageHistory = () => {
  const { mutateAsync: updateMessageHistory, ...result } = useMutation({
    mutationFn: (variables) =>
      MessageHistoryApi.updateMessageHistory(variables),
  });

  return { updateMessageHistory, ...result };
};

/**
 * [MessageHistory] 메시지 전송내역 삭제
 * --
 */
export const useDeleteMessageHistory = () => {
  const { mutateAsync: deleteMessageHistory, ...result } = useMutation({
    mutationFn: (variables) =>
      MessageHistoryApi.deleteMessageHistory(variables),
  });

  return { deleteMessageHistory, ...result };
};
